import { X } from "lucide-react";

export function GameModal({
  open,
  title,
  children,
  primaryText = "確定",
  secondaryText,
  onPrimary,
  onSecondary,
  onClose,
  tone = "info"
}: {
  open: boolean;
  title: string;
  children: React.ReactNode;
  primaryText?: string;
  secondaryText?: string;
  onPrimary?: () => void;
  onSecondary?: () => void;
  onClose: () => void;
  tone?: "info" | "success" | "reward" | "error";
}) {
  if (!open) return null;
  return (
    <div className="game-modal-backdrop">
      <section className={`game-modal ${tone}`}>
        <button className="modal-x" onClick={onClose} aria-label="關閉">
          <X size={18} />
        </button>
        <div className="modal-orb" />
        <h2>{title}</h2>
        <div className="modal-body">{children}</div>
        <div className="modal-actions">
          {secondaryText ? (
            <button className="secondary-cta" onClick={onSecondary ?? onClose}>
              {secondaryText}
            </button>
          ) : null}
          <button className="primary-cta" onClick={onPrimary ?? onClose}>
            {primaryText}
          </button>
        </div>
      </section>
    </div>
  );
}
